"use client";
import { Pagination } from "@/components/pagination/Pagination";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  page: number;
  total: number;
  pathname: string;
  nbPerPage: number;
  hideTopPagination?: boolean;
};
export const ArticleListPageContainer = ({
  children,
  page,
  total,
  pathname,
  nbPerPage,
  hideTopPagination = false,
}: Props) => {
  const router = useRouter();

  const handleClick = (event: React.ChangeEvent<unknown>, value: number) => {
    event.preventDefault();
    const href = value === 1 ? pathname : `${pathname}${value}/`;
    router.push(href);
  };

  return (
    <>
      {!hideTopPagination && (
        <Pagination total={total} page={page} onClick={handleClick} nbPerPage={nbPerPage} hidePageLink />
      )}
      {children}
      <Pagination total={total} page={page} onClick={handleClick} nbPerPage={nbPerPage} />
    </>
  );
};
